import { ProgrammingCategoryRatingPresenter } from '@/presentation/presenters/dashboard/programmingCategoryRatingPresenter'
import { CategoryRatingViewModel } from '@/presentation/viewmodels/dashboard/categoryRatingViewModel'

export function useProgrammingCategoryRatingPresenter(
  presenter: ProgrammingCategoryRatingPresenter = new ProgrammingCategoryRatingPresenter(new CategoryRatingViewModel())
) {
  return {
    isLoading: presenter.isLoading,
    error: presenter.error,
    chartData: presenter.chartData,
    chartSeries: presenter.chartSeries,
    chartOptions: presenter.chartOptions,
    hasData: presenter.hasData,
    initChart: presenter.initChart.bind(presenter)
  }
}
